'use strict';

export default function saInputClear ($document, $timeout) {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function ($scope, $element, $attr, ngModel) {
      let clearButton = angular.element('<button class="ClearButton" type="button" style="display: none"></button>');
      let isHidden = true;

      function showButton() {
        if (isHidden) {
          clearButton.css({
            display: 'block'
          });
          isHidden = false;
        }
      }

      function hideButton() {
        if (!isHidden) {
          clearButton.css({
            display: 'none'
          });
          isHidden = true;
        }
      }

      function isInputEmpty() {
        return !$element.val();
      }

      clearButton.css({
        display: 'none'
      });

      $element.parent().prepend(clearButton);

      $element.on('focus keyup', () => {
        if (!isInputEmpty()) {
          showButton();
        } else {
          hideButton();
        }
      });

      $element.on('blur', () => {
        $timeout(() => {
          hideButton();
        }, 200);
      });

      clearButton.on('click', () => {
        $scope.$apply(() => {
          ngModel.$setViewValue(null);
          ngModel.$commitViewValue();
          ngModel.$render();
          $element[0].focus();
        });
      });

      $element.on('$destroy', () => {

        // Clean up
        clearButton.remove();
      });
    }
  };
}

saInputClear.$inject = [
  '$document',
  '$timeout'
];



// WEBPACK FOOTER //
// ./app/src/directives/input_clear.js